import AllVehiclePage from "pages/vehicle/all/AllVehiclePage"
import AssignedVehiclesPage from "pages/vehicle/assigned/AssignedVehiclesPage"
import TripDetailsPage from "pages/vehicle/trip/TripDetailsPage"
import React from "react"
import { VesaRouteType } from "routes"

export const vehicleRoutes: VesaRouteType[] = [
  {
    path: "all",
    element: <AllVehiclePage />,
  },
  {
    path: "assigned",
    element: <AssignedVehiclesPage />,
  },
  {
    path: "trip/:uuid/:id",
    element: <TripDetailsPage />,
  },
]
